import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {CultureModel} from '../../../../models/localization-and-pricing/culture.model';
import {UserModel} from '../../../../models/authentication/user.model';
import {StudentModel} from '../../../../models/authentication/student.model';
import {SchoolModel} from '../../../../models/school/school.model';
import {TokenModel} from '../../../../models/authentication/token.model';
import {AuthService} from '../../../../services/auth.service';
import {StringExtensionModel} from '../../../../models/extensions/string-extension.model';
import {NavigationModel} from '../../../../models/localization-and-pricing/navigation.model';

@Component({
  selector: 'app-group-sidebar',
  templateUrl: './group-sidebar.component.html',
  styleUrls: ['./group-sidebar.component.css']
})
export class GroupSidebarComponent implements OnInit {

  groupId: string;

  constructor(private router: Router,
              private route: ActivatedRoute,
              private authSv: AuthService) { }

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.groupId = params.groupId;
    });
  }

  /*
  onDashboardClicked() {
    this.router.navigate(['groups', this.groupId, 'dash']);
  }

   */

  dashboardRouterLink(): string {
    return `dash`;
  }

  onStudentsClicked() {
    this.router.navigate(['groupOverview', this.groupId, 'students']);
  }

  onSettingsClicked() {
    this.router.navigate(['groups', this.groupId, 'settings']);
  }

  onLogoutClicked() {

    // Send a signout request.
    this.authSv.signOut().subscribe();

    this.router.navigate(NavigationModel.getHomeURLPaths(['landing']));

    UserModel.setCurrent( null );
    StudentModel.setCurrent( null );
    SchoolModel.setCurrent( null );
    TokenModel.setCurrent( null );

  }


}
